module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAyCAMAAAB8gJvdAAAAOVBMVEU9zMI9zMI9zMI9zMI9zMI9zMI9zMJHcEw9zMI9zMI9zMI9zMI9zMI9zMI9zMI9zMI9zMI9zMI9zMI5YM+kAAAAEnRSTlPg7Osn8MwFAHCA/u5i0FtozilyS0SZAAAAY0lEQVQ4y+2UOxaAIBADw2cBwe/e/7CKfaDAZ8W006TJwIlS5IKoBcHqCTUhEoJRKCIFfV0SpTy6CdQvFD88beqppx7UnQNnT8k/Lt9rb1aqt3cs1UftTfpyWju5zWALmrl3N4MKLnRbVoivAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/手机号.png
// module id = 174
// module chunks = 358